<template>
  <div class="animateContainer">
    <div class="top_container">
      <div class="top_container_inner normal">
        <template v-if="checkStatus">
          <div
              style="flex: 1;display: flex;flex-direction: column;justify-content: center;font-size: 28px;font-weight: bold;color:rgba(0,0,0,0.85)">
            <div style="display: flex;">
              <div v-if="!isGORes">
                <span>正在检查中…</span>
              </div>
              <div v-else>
                    <span>
                      已完成
                      <span class="green">{{ current }}</span>
                      项检查
                    </span>
                <template v-if="!isFinished">
                       <span style="letter-spacing:1px;">
                      ，剩余
                      <span class="red">{{ inCheck }}</span>
                      项检查中
                    </span>
                </template>
              </div>
              <div style="flex: 1"></div>
              <div
                  v-if="!isFinished" v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_revoke'],actionCode:'xsd_pdf_revoke'}" class="stop_btn"
                  @click="cancelCheck">
                取消检查
              </div>
            </div>
            <div style="margin-top: 8px;">
              <div style="font-size: 16px;color: rgba(0, 0, 0, 0.45);line-height: 30px;height: 30px;margin:8px 0px;">
                预计检查时间需要
                <span style="color: #2b8fde">{{ evaluationData.scheduled_time }}</span>，请您耐心等待……
              </div>
            </div>
            <div style="margin-top: 16px;padding-right:24px;box-sizing: border-box ">
              <el-progress :percentage="rate" :show-text="false"></el-progress>
            </div>
          </div>
        </template>
        <template v-else>
          <div style="flex: 1;display: flex;flex-direction: column;justify-content: center;">
            <span style="color: #d9001b;">异常错误</span>
            <span
                v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_restart'],actionCode:'xsd_pdf_restart'}"
                style="
                      width: 80px;
                      padding: 4px 15px;
                      background: #3973FF;
                      box-shadow: 0px 4px 16px rgba(57, 115, 255, 0.245903);
                      border-radius: 20px;
                      color: #fff;
                      text-align: center;
                      cursor: pointer;
                      font-size: 16px;
                      margin-top: 10px;"
                      @click="goStart">
                      重新检查
                    </span>
          </div>
        </template>
      </div>

    </div>
    <div style="flex:1;height: 1px;display: flex;flex-direction: column;">
      <catelogueAnimate></catelogueAnimate>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import catelogueAnimate from "@/views/pdf/processPage/catelogueAnimate";
import {getEvaluation, revoke_task} from "@/api/pdf";

export default {
  name: "processAnimate",
  components: {
    catelogueAnimate
  },
  data() {
    return {
      isGORes: false,
      current: 0,
      total: 0,
      inCheck: 0,
      rate: 0,
    }
  },
  mounted() {

  },
  methods: {
    async cancelCheck() {
      await revoke_task({
        project: this.projectId,
        sign_name: this.sign_name
      })
      this.$emit("revoke")
    },
    goStart() {
      this.$router.push("/")
    },
    ...mapMutations('pdf', ['setEvaluationData'])
  },
  computed: {
    ...mapState('pdf', ['evaluationData', 'processData', 'isFinished', "projectId", 'sign_name']),
    checkStatus() {
      if (this.evaluationData.status == '1') {
        return false
      } else {
        return true
      }
    },
  },
  watch: {
    "processData": {
      async handler(processData) {
        let val = processData.process;
        if (val <= 2) {
          this.isGORes = false;
        } else if (val >= 3) {
          this.isGORes = true;
        }
        try {
          let res = await getEvaluation({
            project: this.projectId,
            sign_name: this.sign_name
          })
          this.setEvaluationData(res.data);
          this.total = this.evaluationData.total_part;
          if (this.processData.current == -1) {
            this.current = this.total;
          } else {
            this.current = this.processData.current;
          }
          this.inCheck = this.total - this.current;
          this.rate = (Number(this.current / this.total).toFixed(2)) * 100;
        } catch (err) {
          console.log(err)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.animateContainer {
  flex: 1;
  height: 1px;
  width: 100%;
  margin: 0px auto 0px auto;
  display: flex;
  flex-direction: column;

  .top_container {
    background-color: #EBF1FD;
    flex-shrink: 0;
    height: 200px;

    .normal {
      background-image: url("~@/assets/image/normal.gif");
      background-repeat: no-repeat;
      mix-blend-mode: darken;
    }

    .warning {
      background-image: url("~@/assets/image/warning.gif");
      background-repeat: no-repeat;
      mix-blend-mode: darken;
    }

    .top_container_inner {
      height: 200px;
      display: flex;
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      padding-left: 200px;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;

      .stop_btn {
        width: 110px;
        height: 32px;
        line-height: 32px;
        border: 1px solid #FF7D00;
        box-sizing: border-box;
        border-radius: 32px;
        font-size: 14px;
        color: #FF7D00;
        background-image: url("~@/assets/image/Vector.png");
        background-repeat: no-repeat;
        background-position: 10px center;
        background-size: 16px;
        padding-left: 35px;
        cursor: pointer;
      }
    }
  }

  .stepTwo_body {
    flex: 1;
    height: 1px;
    width: 1200px;
    margin: 16px auto;
    background-color: #fff;
    box-sizing: border-box;
    padding: 24px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

  }
}

.s_title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  height: 25px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.85);
}

.red {
  color: #F53F3F;
}

.green {
  color: #00B42A;
}
</style>
